// source: v2/cdr_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var v2_types_cdr_pb = require('../v2/types/cdr_pb.js');
goog.object.extend(proto, v2_types_cdr_pb);
goog.exportSymbol('proto.loopup.ctgateway.v2.GetCdrByCallIdRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.GetCdrByCallIdResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.GetCdrByTimeRangeRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.GetCdrByCallIdRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.GetCdrByCallIdRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.GetCdrByCallIdRequest.displayName = 'proto.loopup.ctgateway.v2.GetCdrByCallIdRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.GetCdrByCallIdResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.GetCdrByCallIdResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.GetCdrByCallIdResponse.displayName = 'proto.loopup.ctgateway.v2.GetCdrByCallIdResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.GetCdrByTimeRangeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.GetCdrByTimeRangeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.GetCdrByTimeRangeRequest.displayName = 'proto.loopup.ctgateway.v2.GetCdrByTimeRangeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse.repeatedFields_, null);
};
goog.inherits(proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse.displayName = 'proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.GetCdrByCallIdRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.GetCdrByCallIdRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.GetCdrByCallIdRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetCdrByCallIdRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    callId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.GetCdrByCallIdRequest}
 */
proto.loopup.ctgateway.v2.GetCdrByCallIdRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.GetCdrByCallIdRequest;
  return proto.loopup.ctgateway.v2.GetCdrByCallIdRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.GetCdrByCallIdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.GetCdrByCallIdRequest}
 */
proto.loopup.ctgateway.v2.GetCdrByCallIdRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCallId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.GetCdrByCallIdRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.GetCdrByCallIdRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.GetCdrByCallIdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetCdrByCallIdRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCallId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string call_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v2.GetCdrByCallIdRequest.prototype.getCallId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.GetCdrByCallIdRequest} returns this
 */
proto.loopup.ctgateway.v2.GetCdrByCallIdRequest.prototype.setCallId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.GetCdrByCallIdResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.GetCdrByCallIdResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.GetCdrByCallIdResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetCdrByCallIdResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    cdr: (f = msg.getCdr()) && v2_types_cdr_pb.Cdr.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.GetCdrByCallIdResponse}
 */
proto.loopup.ctgateway.v2.GetCdrByCallIdResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.GetCdrByCallIdResponse;
  return proto.loopup.ctgateway.v2.GetCdrByCallIdResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.GetCdrByCallIdResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.GetCdrByCallIdResponse}
 */
proto.loopup.ctgateway.v2.GetCdrByCallIdResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v2_types_cdr_pb.Cdr;
      reader.readMessage(value,v2_types_cdr_pb.Cdr.deserializeBinaryFromReader);
      msg.setCdr(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.GetCdrByCallIdResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.GetCdrByCallIdResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.GetCdrByCallIdResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetCdrByCallIdResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCdr();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      v2_types_cdr_pb.Cdr.serializeBinaryToWriter
    );
  }
};


/**
 * optional Cdr cdr = 1;
 * @return {?proto.loopup.ctgateway.v2.Cdr}
 */
proto.loopup.ctgateway.v2.GetCdrByCallIdResponse.prototype.getCdr = function() {
  return /** @type{?proto.loopup.ctgateway.v2.Cdr} */ (
    jspb.Message.getWrapperField(this, v2_types_cdr_pb.Cdr, 1));
};


/**
 * @param {?proto.loopup.ctgateway.v2.Cdr|undefined} value
 * @return {!proto.loopup.ctgateway.v2.GetCdrByCallIdResponse} returns this
*/
proto.loopup.ctgateway.v2.GetCdrByCallIdResponse.prototype.setCdr = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.GetCdrByCallIdResponse} returns this
 */
proto.loopup.ctgateway.v2.GetCdrByCallIdResponse.prototype.clearCdr = function() {
  return this.setCdr(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.GetCdrByCallIdResponse.prototype.hasCdr = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.GetCdrByTimeRangeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.GetCdrByTimeRangeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.GetCdrByTimeRangeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetCdrByTimeRangeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    startDate: jspb.Message.getFieldWithDefault(msg, 1, ""),
    endDate: jspb.Message.getFieldWithDefault(msg, 2, ""),
    page: (f = msg.getPage()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    limit: (f = msg.getLimit()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    showInvalidOriginatingNumbers: (f = msg.getShowInvalidOriginatingNumbers()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.GetCdrByTimeRangeRequest}
 */
proto.loopup.ctgateway.v2.GetCdrByTimeRangeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.GetCdrByTimeRangeRequest;
  return proto.loopup.ctgateway.v2.GetCdrByTimeRangeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.GetCdrByTimeRangeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.GetCdrByTimeRangeRequest}
 */
proto.loopup.ctgateway.v2.GetCdrByTimeRangeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStartDate(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEndDate(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setPage(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setLimit(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setShowInvalidOriginatingNumbers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.GetCdrByTimeRangeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.GetCdrByTimeRangeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.GetCdrByTimeRangeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetCdrByTimeRangeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStartDate();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEndDate();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPage();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getLimit();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getShowInvalidOriginatingNumbers();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string start_date = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v2.GetCdrByTimeRangeRequest.prototype.getStartDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.GetCdrByTimeRangeRequest} returns this
 */
proto.loopup.ctgateway.v2.GetCdrByTimeRangeRequest.prototype.setStartDate = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string end_date = 2;
 * @return {string}
 */
proto.loopup.ctgateway.v2.GetCdrByTimeRangeRequest.prototype.getEndDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.GetCdrByTimeRangeRequest} returns this
 */
proto.loopup.ctgateway.v2.GetCdrByTimeRangeRequest.prototype.setEndDate = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.Int32Value page = 3;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.loopup.ctgateway.v2.GetCdrByTimeRangeRequest.prototype.getPage = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 3));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.loopup.ctgateway.v2.GetCdrByTimeRangeRequest} returns this
*/
proto.loopup.ctgateway.v2.GetCdrByTimeRangeRequest.prototype.setPage = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.GetCdrByTimeRangeRequest} returns this
 */
proto.loopup.ctgateway.v2.GetCdrByTimeRangeRequest.prototype.clearPage = function() {
  return this.setPage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.GetCdrByTimeRangeRequest.prototype.hasPage = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Int32Value limit = 4;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.loopup.ctgateway.v2.GetCdrByTimeRangeRequest.prototype.getLimit = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 4));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.loopup.ctgateway.v2.GetCdrByTimeRangeRequest} returns this
*/
proto.loopup.ctgateway.v2.GetCdrByTimeRangeRequest.prototype.setLimit = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.GetCdrByTimeRangeRequest} returns this
 */
proto.loopup.ctgateway.v2.GetCdrByTimeRangeRequest.prototype.clearLimit = function() {
  return this.setLimit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.GetCdrByTimeRangeRequest.prototype.hasLimit = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.BoolValue show_invalid_originating_numbers = 6;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.loopup.ctgateway.v2.GetCdrByTimeRangeRequest.prototype.getShowInvalidOriginatingNumbers = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 6));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.GetCdrByTimeRangeRequest} returns this
*/
proto.loopup.ctgateway.v2.GetCdrByTimeRangeRequest.prototype.setShowInvalidOriginatingNumbers = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.GetCdrByTimeRangeRequest} returns this
 */
proto.loopup.ctgateway.v2.GetCdrByTimeRangeRequest.prototype.clearShowInvalidOriginatingNumbers = function() {
  return this.setShowInvalidOriginatingNumbers(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.GetCdrByTimeRangeRequest.prototype.hasShowInvalidOriginatingNumbers = function() {
  return jspb.Message.getField(this, 6) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    totalRecords: (f = msg.getTotalRecords()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    page: (f = msg.getPage()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    recordsPerPage: (f = msg.getRecordsPerPage()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    cdrsList: jspb.Message.toObjectList(msg.getCdrsList(),
    v2_types_cdr_pb.Cdr.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse}
 */
proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse;
  return proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse}
 */
proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setTotalRecords(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setPage(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setRecordsPerPage(value);
      break;
    case 4:
      var value = new v2_types_cdr_pb.Cdr;
      reader.readMessage(value,v2_types_cdr_pb.Cdr.deserializeBinaryFromReader);
      msg.addCdrs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalRecords();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getPage();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getRecordsPerPage();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getCdrsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      v2_types_cdr_pb.Cdr.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Int32Value total_records = 1;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse.prototype.getTotalRecords = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 1));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse} returns this
*/
proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse.prototype.setTotalRecords = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse} returns this
 */
proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse.prototype.clearTotalRecords = function() {
  return this.setTotalRecords(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse.prototype.hasTotalRecords = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Int32Value page = 2;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse.prototype.getPage = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 2));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse} returns this
*/
proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse.prototype.setPage = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse} returns this
 */
proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse.prototype.clearPage = function() {
  return this.setPage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse.prototype.hasPage = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Int32Value records_per_page = 3;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse.prototype.getRecordsPerPage = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 3));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse} returns this
*/
proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse.prototype.setRecordsPerPage = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse} returns this
 */
proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse.prototype.clearRecordsPerPage = function() {
  return this.setRecordsPerPage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse.prototype.hasRecordsPerPage = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated Cdr cdrs = 4;
 * @return {!Array<!proto.loopup.ctgateway.v2.Cdr>}
 */
proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse.prototype.getCdrsList = function() {
  return /** @type{!Array<!proto.loopup.ctgateway.v2.Cdr>} */ (
    jspb.Message.getRepeatedWrapperField(this, v2_types_cdr_pb.Cdr, 4));
};


/**
 * @param {!Array<!proto.loopup.ctgateway.v2.Cdr>} value
 * @return {!proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse} returns this
*/
proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse.prototype.setCdrsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.loopup.ctgateway.v2.Cdr=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v2.Cdr}
 */
proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse.prototype.addCdrs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.loopup.ctgateway.v2.Cdr, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse} returns this
 */
proto.loopup.ctgateway.v2.GetCdrByTimeRangeResponse.prototype.clearCdrsList = function() {
  return this.setCdrsList([]);
};


goog.object.extend(exports, proto.loopup.ctgateway.v2);
